module.exports = __webpack_public_path__ + "static/media/workshop_featured_emptystate.ac839626.svg";